import { useState } from 'react'

import classNames from 'classnames'

import type { ImageProps } from '~/components/atoms/Image/Image'
import type { TIntroAdvertPosition } from '~/components/report/types'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'
import { useScrollPosition } from '~/utils/useScrollPosition'

import ImageRelative from '../../components/ImageRelative/ImageRelative'
import type { IReportAdvert } from '../ReportAdvert/ReportAdvert'
import ReportAdvert from '../ReportAdvert/ReportAdvert'

import styles from './StickyAdvert.module.css'

export interface StickyAdvertProps extends IReportAdvert {
  image: ImageProps
  landscapeImage: ImageProps
  link: string
  position: TIntroAdvertPosition
  isSticky?: boolean
  stickyPosition?: number
  stickyEndPosition?: number
  isPortrait?: boolean
}

export default function StickyAdvert({
  image,
  landscapeImage,
  link,
  isSticky = false,
  stickyPosition,
  stickyEndPosition,
  isPortrait = true,
  title,
  introduction,
  modalImage,
}: StickyAdvertProps) {
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)
  const [beSticky, setBeSticky] = useState(false)

  useScrollPosition(
    ({ currPos }) => {
      if (!stickyPosition || !stickyEndPosition) return

      let currentScrollPosition = Math.abs(Math.round(currPos.y))

      if (isMobile) {
        currentScrollPosition = Math.abs(Math.round(currPos.y)) + 70
      }

      const isSticky =
        currentScrollPosition >= stickyPosition &&
        currentScrollPosition < stickyEndPosition + 100

      setBeSticky(isSticky)
    },
    [stickyPosition, stickyEndPosition, isMobile]
  )

  return (
    <div
      className={classNames(
        styles.reportAdvertContainer,
        isSticky && styles.reportAdvertSticky,
        isSticky && beSticky && styles.reportAdvertBeSticky
      )}
    >
      <div className={styles.advertInner}>
        <div
          className={classNames(
            styles.reportAdvert,
            isPortrait && !isMobile && styles.reportAdvertPortrait
          )}
        >
          <ReportAdvert
            title={title}
            modalImage={modalImage}
            introduction={introduction}
            link={link}
          >
            <ImageRelative
              image={!isMobile ? image : landscapeImage}
              marginBottom={false}
            />
          </ReportAdvert>
        </div>
      </div>
    </div>
  )
}
